import { Company } from './Company'

/**
 *
 * Order
 * @class Order
 */
export class Order {

    /**
     * Creates an instance of Order.
     * @param { OrderObj } orderObj
     * @memberof Order
     */

    constructor(orderObj) {
        if(typeof orderObj === 'undefined' || orderObj === null){
            orderObj = {}
        }

        this.id            = orderObj.id || null
        this.company_id    = orderObj.company_id || null
        this.coupon_id     = orderObj.coupon_id || null
        this.description   = orderObj.description || null
        this.currency      = orderObj.currency || null
        this.amount        = orderObj.amount || 0.00
        this.discount      = orderObj.discount || 0.00
        this.final_amount  = orderObj.final_amount || 0.00
        this.code          = orderObj.code || null
        this.method        = orderObj.method || null
        this.status        = orderObj.status || null
        this.url           = orderObj.url || null
        this.observations  = orderObj.observations || null
        this.created_at    = new Date(orderObj.created_at || null)
        this.due           = new Date(orderObj.due || null)
        this.is_due        = orderObj.is_due || false

        this.company = (typeof  orderObj.company != "undefined") ? new Company(orderObj.company) : new Company()

        this.items         = []

        this.class         = 'bg-primary'

        switch (orderObj.status) {
            case 'pendding':
                this.class = 'warning';
                break;
            case 'processing':
                this.class = 'info';
                break;
            case 'paid':
                this.class = 'success';
                break;
            case 'due':
                this.class = 'danger';
                break;
            case 'canceled':
                this.class = 'primary';
                break;
            case 'draft':
                this.class = 'primary';
                break;
        }

        if(orderObj.is_due){
            this.class  = 'danger';
            this.status = 'due';
        }



        if(orderObj.items){
            this.items = orderObj.items.map(item => {
                return item
            })
        }
    }

    /**
     * Creates an instance of Order.
     * @param { OrderObj } orderObj
     * @memberof Order
     * @returns { Order }
     */
    static init(orderObj) {
        return new Order(orderObj)
    }
}
